import { useState, useMemo, useEffect, startTransition } from 'react';
import { useIamUserProfileStore } from '../../Store';
import { UserStores } from './UserStores';

const createOptions = (iamUserInfo: any) =>
  iamUserInfo?.fullUser?.stores?.map((store: any) => ({
    label: `${store.name} - ${store.id}`,
    value: store.id,
    isDefault: store.defaultStore,
  })) || [];

const findDefaultStore = (options: any) =>
  options.find((store: any) => store.isDefault);

export default function UserStoreDropdown({
    handleSelectedOption,
    handleClear,
    handleDefaultOption
  }: any): JSX.Element {
  const [selectedOption, setSelectedOption] = useState({ label: '' } as any);
  const iamUserInfo = useIamUserProfileStore((state: any) => state.iamUserInfo);

  const options = useMemo(() => {
    const stores = createOptions(iamUserInfo);
    return stores.sort((a: any, b: any) => a.label.localeCompare(b.label));
  }, [iamUserInfo]);

  const handleSelectionChange = (store: string) => {
    startTransition(() => {
      const selected = options.find((option: any) => option.value === store);
      setSelectedOption(selected);
      handleSelectedOption(selected.label,selected.value);
    });
  };

  useEffect(() => {
    if (iamUserInfo) {
      startTransition(() => {
        const defaultStore = findDefaultStore(options);
        if (defaultStore) {
          setSelectedOption(defaultStore);
          handleDefaultOption(defaultStore.label,defaultStore.value);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iamUserInfo, options]);

  return (
    <>
      <UserStores
        id="ip-restriction-store"
        defaultOptions={options}
        selected={selectedOption}
        onSelectionChange={handleSelectionChange}
        onClear={handleClear}
      />
    </>
  );
}
